import apiFetch from '../apiFetch'

export default function (documentId, token, file, lastAccessDate) {
  const formData = new FormData()
  formData.append(file.name, file)
  return apiFetch({ endPoint: `document/${documentId}/Sheet`, method: 'POST', body: formData, token: token, fileBody: true, lastAccessDate })
}
